import "./board.css";
import Tile from "../Tile";

const Board = ({board, scale, clickBoardTile, setOverBoard}) => {
    // console.log("BOARD", scale * 16)
    return (
        <div id="board" className="board" style={{padding: `${(scale / 2) - (3 * scale / 100)}px`, width: "100%", margin: "0 auto"}} onMouseEnter={() => setOverBoard(true)} onMouseLeave={() => setOverBoard(false)}>
            {board?.rows?.map((row, i) => <div key={`row${i}`} className=" d-flex boardRow">
                {row.spaces.map((space, j) => (
                    <div onClick={() => clickBoardTile(space)} key={`space${i}${j}`} 
                        className={`space 
                            ${space.letterMultiplier ? "letterx" + space.letterMultiplier : ""} 
                            ${space.wordMultiplier ? "wordx" + space.wordMultiplier : ""} 
                            ${board.rows[i-1]?.spaces[j].letterMultiplier > 1 ? "belowLetterx" + board.rows[i-1]?.spaces[j].letterMultiplier : ""}
                            ${board.rows[i-1]?.spaces[j].wordMultiplier > 1 ? "belowWordx" + board.rows[i-1]?.spaces[j].wordMultiplier : ""}`}
                        style={{
                            width: `${j == row.spaces.length - 1 ? scale + (3 * scale / 50) : scale}px`,
                            height: `${i == board.rows.length - 1 ? scale + (3 * scale / 50) : scale}px`,
                            fontSize: `${scale / 5}px`,
                            borderLeftWidth: `${3 * scale / 50}px`,
                            borderTopWidth: `${3 * scale / 50}px`,
                            borderRightWidth: `${j == row.spaces.length - 1 ? 3 * scale / 50 : 0}px`,
                            borderBottomWidth: `${i == board.rows.length - 1 ? 3 * scale / 50 : 0}px`
                        }}
                    >{space.tile ? <Tile letter={(space.tile.tile ?? space.tile).letter} points={(space.tile.tile ?? space.tile).value} scale={scale * .95 } />: ""}
                    {/* {space.isNew ? <div className="isNew">*</div> : <></>} */}
                        </div>
                ))}
            </div>)}
        </div>
    )
}

export default Board;